import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { biographyApi } from '../api/biography-api';
import { BiographyController } from '../stores/biography-controller';
export function useHeroBiography(heroId: number | null) {
  const controller = useMemo(() => new BiographyController(heroId, biographyApi), [heroId]);
  const state = useSyncExternalStore(controller.subscribe, controller.getSnapshot, controller.getSnapshot);
  useEffect(() => { controller.start(); return controller.stop; }, [controller]);
  return { ...state, submit: controller.submit, refresh: controller.refresh };
}
